<template>
    <Multiselect
        v-model="userTypes" 
        ref="userMultiselectComponent"
        :options="specificContextUsersList?specificContextUsersList:userTypesOptions"
        :multiple="enableCheckbox?true:false"
        track-by="_id"
        :custom-label="userTypeLabelCallback"
        :close-on-select="closeOnSelect!=undefined?false:true"
        deselectLabel =""
        selectLabel=""
        selectedLabel=""
        :placeholder="customizeLabel!= undefined?customizeLabel:(customizePlaceholder != undefined?customizePlaceholder:enableCheckbox?'Enter username':'Search User')" 
        :hideSelected="false"
        @open="checkIsEditingDescription(); getAllUserNamesFromServer()"
        @search-change="getusersOnKeyup($event)"
        @remove="userTypeOnRemove($event)"
        @select="enableCheckbox?userTypeOnSelect($event):optionsOnSelectCallback($event)"
        :searchable="isSearchable"
        @close="handleClose"
        :openDirection="dropdownOpenDirection?dropdownOpenDirection:''"
        >
        <div v-if="enableSelectedCount && userTypes.length > 1" :title="option.option.username" slot="tag" slot-scope="option" class="tags-style name-count-parent-wrap" :style="option.option._id != userTypes[0]._id? 'display:none':''" >
          <div  v-if="option.option._id == userTypes[0]._id && customizeLabel!=undefined" class="customisez-label">{{customizeLabel + " : "}} </div>
            <div v-if="option.option._id == userTypes[0]._id" class="name-count-wrap">
              <div  :title="option.option.username" v-if="Object.keys(option.option).includes('profile_image') && !['undefined',null].includes(option.option.profile_image) && option.option.profile_image" class='user-name-or-image-in-selected-option'>
                  <img :src="getProxyConvertedImage(option.option.profile_image)" @error="replaceWithUserIcon($event,option.option.username)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
              </div>
              <div v-else class="user-name-or-image-in-selected-option" :style="style(option.option.username)">{{ option.option.username.split("")[0] }}</div>
              <div class="user-name-display user-name-display-as-tags ellipsis-to-entry">{{option.option.username}}</div>
              <!-- <div class="remove-tag" v-on:click="removeSelectedOption(option.option)">
                <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
              </div> -->
               <div v-if="userTypes.length>1" class="count-wrapper" style="background: #4e4e4e;padding: 2px 4px;border: 1px solid #202020;border-radius: 8px;margin-inline-start: 3px;"> +{{userTypes.length -1}}</div>
            </div>  
        </div>

        <div v-else slot="tag" :title="option.option.username"  slot-scope="option" class="tags-style" :class="option.option._id == userTypes[0]._id && enableSelectedCount?'name-count-parent-wrap':''">
          <div v-if="option.option._id == userTypes[0]._id && customizeLabel!=undefined" class="customisez-label" style="margin-inline-end:5px;line-height: 27px;margin-inline-start: 8px;">{{customizeLabel + " : "}} </div>
            <div :title="option.option.username" v-if="Object.keys(option.option).includes('profile_image') && !['undefined',null].includes(option.option.profile_image) && option.option.profile_image" class='user-name-or-image-in-selected-option'>
                  <img :src="getProxyConvertedImage(option.option.profile_image)" @error="replaceWithUserIcon($event,option.option.username)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
              </div>
            <div v-else class="user-name-or-image-in-selected-option" :style="style(option.option.username)">{{ option.option.username.split("")[0] }}</div>
            <div class="user-name-display user-name-display-as-tags ellipsis-to-entry">{{option.option.username}}</div>
            <div class="remove-tag" v-on:click.stop.prevent="removeSelectedOption(option.option)" :style="enableSelectedCount?'display:none':''">
              <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            </div>
        </div>

        <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
          <input v-if="enableCheckbox" type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeCheckBoxSelection(scope.option)" @focus.prevent :key="scope.option.username"/>
          <div v-if="Object.keys(scope.option).includes('profile_image') && !['undefined',null].includes(scope.option.profile_image) && scope.option.profile_image" class='user-name-or-image'>
              <img :src="getProxyConvertedImage(scope.option.profile_image)" @error="replaceWithUserIcon($event,scope.option.username)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px;margin-bottom: 5px">
          </div>
          <div v-else class="user-name-or-image" :style="style(scope.option.username)">{{ scope.option.username.split("")[0] }}</div>
          <span style="margin-inline-start:12px;">{{ scope.option.username }}</span>
        </div>
        <span slot="noResult">No results</span>
        <span slot="noOptions" style="display:none"></span>
        
        <template v-if="![undefined,null].includes(showOptionLabel) && showOptionLabel && !showonlySelectedUserImage" slot="singleLabel" slot-scope="{ option }">{{customizePlaceholder}} : {{option.username}}</template>
        <template v-if="showonlySelectedUserImage && option.username" slot="singleLabel" slot-scope="{ option }"> 
         <div v-if="Object.keys(option).includes('profile_image') && !['undefined',null].includes(option.profile_image) && option.profile_image" class='user-name-or-image'>
              <img :src="getProxyConvertedImage(option.profile_image)" @error="replaceWithUserIcon($event,option.username)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px;margin-bottom: 5px">
          </div>
          <div v-else class="user-name-or-image" :style="style(option.username)">{{ option.username.split("")[0] }}</div>
        </template>
    </Multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import {mapActions,mapGetters} from "vuex";
import Utils from "../../components.utils.js";


export default {
      props:["enableCheckbox","selectedUserIdList","selectedUserIdNameMap","componentUuid","loggedInUserDataList",
              "enableAllOption","isSearchable","customizeLabel", "enableSelectedCount", "closeOnSelect","customizePlaceholder",
              "filterContext","showOptionLabel",'filterByUT',"dropdownOpenDirection","privilegeCheck", "specificContextUsersList","showonlySelectedUserImage"],
      data() {
            return {
                userTypes: [],
                userTypesOptions: [],
                userIdList:[],
                allUsersData:{"_id":"all","username":"All"},
                defaultUserTypes:null
            }
        },
        components:{
            "Multiselect":Multiselect,
        },

        watch:{
          loggedInUserDataList(newval){
            this.userTypes = newval;
          },
          "selectedUserIdList":function(newVal){
            if(newVal){
              // this.selectedUserIdList = newVal;
              if(![undefined, null].includes(this.selectedUserIdList) && this.selectedUserIdList.length > 0){
                if(Object.prototype.toString.call(this.selectedUserIdList) == '[object String]'){
                  Object.assign(this.userIdList,[this.selectedUserIdList]);
                }else{
                  Object.assign(this.userIdList,this.selectedUserIdList);
                }
                  this.fetchAndLoadUserNamesById();
              }else{
                if(!this.enableCheckbox){
                  this.selectedUserIdList = ""
                  this.userTypes = {};
                  this.userIdList = [];
                }else{
                  this.userTypes = [];
                }
              }
            }
          }
        },

        methods:{
            getProxyConvertedImage(image_url){
                return Utils.convertToLoginIPDomainName(image_url);
            },
            handleClose() {
              this.$emit('close'); // Emit the custom close event to the parent component
            },
            style(name){
                let style = {
                'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
                }
                return style
            },
            getProfileImageOfUser(image){
              let defaultImage = Utils.getNoThumbnailImg()
              let profileImageTag = '<img src='+this.getProxyConvertedURL(image)+' onerror="this.src='+defaultImage+'; this.onerror = null" style="width: 100%;border-radius: 6px;height: 100%;margin-bottom: 3px;">'
                return profileImageTag;
            },
            replaceWithUserIcon(e){
                e.target.onerror = null
                e.target.src = Utils.getNoThumbnailImg();
            },
            userTypeLabelCallback(option){
              let uName = ""
              if(![undefined,null].includes(option) && Object.keys(option).length > 0){
                uName = option.username
              }
              if(this.customizeLabel != undefined){
                  return `${this.customizeLabel +" : "+ uName}`
              }else{
                return `${uName}`
              }
            },
            getusersOnKeyup(option){
              if(!this.isSearchable){
                this.appendCurrentUserDetails();
                return;
              }
                let payload = {params:{}};
                if(typeof(option) != "undefined" && option.trim().length > 0){

                    // payload.params = {username:option}  //********************************
                   
                    if(this.defaultUserTypes && Array.isArray(this.defaultUserTypes) && this.defaultUserTypes.length>0){
                      payload.params = {username:option, user_type:JSON.stringify(this.defaultUserTypes)};
                    }else{
                      payload.params = {username:option}
                    }

                    let respData = null;
                    // if(this.privilegeCheck && this.privilegeCheck == 'review'){
                    //   let tempPayload = {};
                    //   tempPayload.params = {'username':option};
                    //   this.getReviewUsersWithAutocomplete(tempPayload).then((data) => {
                    //     respData = data["users"];
                    //     if(respData){
                    //       this.userTypesOptions = respData
                    //       if(this.enableAllOption != undefined && this.enableAllOption){
                    //         this.userTypesOptions.unshift(this.allUsersData)
                    //       }
                    //     }
                    //   });
                    // }else{
                      if(this.privilegeCheck && this.privilegeCheck.length){
                        payload.params["privilege"] = this.privilegeCheck
                      }
                      payload.params["status"] = "active"
                      this.getUsersAutoComplitionFromServer(payload).then((data) => {
                        respData = data["users"];
                        if(respData){
                          if(this.privilegeCheck && this.privilegeCheck.trim().length && ['Share','Review'].includes(this.privilegeCheck) && (!this.filterContext || this.filterContext != 'review-workspace-filter')){
                            this.userTypesOptions = respData.filter(e => e._id != this.getLoggedInUserId())
                          }else{
                            this.userTypesOptions = respData;
                          }
                          if(this.enableAllOption != undefined && this.enableAllOption){
                            this.userTypesOptions.unshift(this.allUsersData)
                          }
                        }
                      });
                    // }
                }else if(option.length==0){
                  if(this.defaultUserTypes && Array.isArray(this.defaultUserTypes) && this.defaultUserTypes.length>0){
                    payload.params = {user_type:JSON.stringify(this.defaultUserTypes)};
                  }

                  let respData = null;
                  // if(this.privilegeCheck && this.privilegeCheck == 'review'){
                  //   this.getReviewUsersWithAutocomplete(payload).then((data) => {
                  //     respData = data["users"];
                  //     if(respData){
                  //       this.userTypesOptions = respData
                  //       if(this.enableAllOption != undefined && this.enableAllOption){
                  //         this.userTypesOptions.unshift(this.allUsersData)
                  //       }
                  //     }
                  //   });
                  // }else{
                    if(this.privilegeCheck && this.privilegeCheck.length){
                      payload.params["privilege"] = this.privilegeCheck
                    }
                    payload.params["status"] = "active"
                    this.getUsersAutoComplitionFromServer(payload).then((data) => {
                      respData = data["users"];
                      if(respData){
                        if(this.privilegeCheck && this.privilegeCheck.trim().length && ['Share','Review'].includes(this.privilegeCheck) && (!this.filterContext || this.filterContext != 'review-workspace-filter')){
                          this.userTypesOptions = respData.filter(e => e._id != this.getLoggedInUserId())
                        }else{
                          this.userTypesOptions = respData;
                        }
                        if(this.enableAllOption != undefined && this.enableAllOption){
                          this.userTypesOptions.unshift(this.allUsersData)
                        }
                      }
                    });
                  // }
                }
            },
            getAllUserNamesFromServer(){
              if(!this.isSearchable){
                this.appendCurrentUserDetails();
                return;
              }
                let payload = {params:{}};
                if(this.defaultUserTypes && Array.isArray(this.defaultUserTypes) && this.defaultUserTypes.length>0){
                  payload.params = {user_type:JSON.stringify(this.defaultUserTypes)};
                }

                // if(this.privilegeCheck && this.privilegeCheck == 'review'){
                //   this.getReviewUsersWithAutocomplete(payload).then((data)=>{
                //     this.userTypesOptions = data.users;
                //     if(this.enableAllOption != undefined && this.enableAllOption){
                //           this.userTypesOptions.unshift(this.allUsersData)
                //       }
                //     });
                // }else{
                  if(this.privilegeCheck && this.privilegeCheck.length){
                    payload.params["privilege"] = this.privilegeCheck
                  }
                  payload.params["status"] = "active"
                  this.getUsersAutoComplitionFromServer(payload).then((data) => {
                    if(this.privilegeCheck && this.privilegeCheck.trim().length && ['Share','Review'].includes(this.privilegeCheck) && (!this.filterContext || this.filterContext != 'review-workspace-filter')){
                      this.userTypesOptions = data.users.filter(e => e._id != this.getLoggedInUserId());
                    }else{
                       this.userTypesOptions = data.users;
                    }
                  if(this.enableAllOption != undefined && this.enableAllOption){
                        this.userTypesOptions.unshift(this.allUsersData)
                    }
                  });
                // }
            },
            userTypeOnSelect(option){
              if(!this.isSearchable){
                return;
              }
             let index = this.userTypesOptions.findIndex(item => item._id == option._id);
                 if(index > -1){
                     this.userTypesOptions[index].checked = true;
                     if(!this.userIdList.includes(option._id))this.userIdList.push(option._id)
                     if(this.componentUuid != undefined){
                         this.$emit("updatedUsersList",option._id,this.componentUuid);
                         this.$emit("selectedUserCompleteData",option)
                     }else{
                         this.$emit("updatedUsersList",option._id);
                         this.$emit("selectedUserCompleteData",option)
                     }
                 }
             },
             userTypeOnRemove(option){
               if(Object.prototype.toString.call(this.userTypes) == '[object Array]'){
                  let index = this.userTypes.findIndex(item => item._id == option._id);
                  if(index > -1){
                      this.userTypes[index].checked = false;
                      this.userIdList = this.userIdList.filter(e => e != option._id);
                      this.userTypes = this.userTypes.filter(e => e._id != option._id);
                      if(Object.prototype.toString.call(this.selectedUserIdList) == '[object Array]'){
                      this.selectedUserIdList = this.selectedUserIdList.filter(e => e != option._id)
                      }
                      if(this.componentUuid != undefined){
                          this.$emit("removedUserFromList",option._id,this.componentUuid)
                         this.$emit("removedUserCompleteData",option)
                      }else{
                          this.$emit("removedUserFromList",option._id)
                         this.$emit("removedUserCompleteData",option)
                      }
                  }
               }else{
                  if(this.componentUuid != undefined){
                      this.$emit("removedUserFromList",option._id,this.componentUuid)
                         this.$emit("removedUserCompleteData",option)
                  }else{
                      this.$emit("removedUserFromList",option._id)
                         this.$emit("removedUserCompleteData",option)
                  } 
               } 
             },
             makeCheckBoxSelection(option){
                 if((this.selectedUserIdNameMap != undefined && this.userTypes.length) || this.userTypes.length){
                     return this.userTypes.some((op) => op._id === option._id);
                 }
             },
            removeSelectedOption(option){
              if(!this.isSearchable){
                return;
              }
              let indexOfSelectedOption = this.userTypes.findIndex((e) => e._id == option._id);
              if(indexOfSelectedOption > -1){
                  this.userTypeOnRemove(option);
                  this.userTypes.splice(indexOfSelectedOption,1);
              }
            },
            optionsOnSelectCallback(option){
              this.userTypes = option;
              if(this.componentUuid != undefined){
                  this.$emit("updatedUsersList",this.userTypes,this.componentUuid)
              }else{
                  this.$emit("updatedUsersList",this.userTypes)
              }
            },
            getUserIdNameMap(){
                return this.userIdList; 
            },
            getComponentUuid(){
                return this.componentUuid;
            },
            appendCurrentUserDetails(){
              this.userTypesOptions = [{"username":this.getLoggedInUser(),"_id":this.getLoggedInUserId()}];
            },
            fetchAndLoadUserNamesById(){
              this.userTypes = [];
              for(let opId of this.userIdList){
                  let payload = { params: {filter:JSON.stringify(["username","profile_image","email"])}}
                  if(!(['all',"All",undefined].includes(opId))){
                    payload.params["userId"] = opId;
                  }else if(this.enableAllOption != undefined && this.enableAllOption){
                    this.userTypes.push(this.allUsersData)
                  }
                  if(this.privilegeCheck && this.privilegeCheck == 'review'){
                    let tempPayload = {params:{}};
                    tempPayload.params['userId'] = opId;
                    this.getReviewUsersWithAutocomplete(tempPayload).then((data)=>{
                      if(typeof(data) != "undefined" || data.users != null){
                        let userInfo = data["users"][0];
                        if(userInfo){
                          userInfo["checked"] = true
                          this.userTypes.push(userInfo);
                        }
                      }
                    })
                  }else{
                    this.getUserInfoFromServer(payload).then((data)=>{
                      if(typeof(data) != "undefined" || data.user != null){
                        let userInfo = data["user"];
                        if(userInfo){
                          userInfo["checked"] = true
                          this.userTypes.push(userInfo)
                        }
                      }
                    })
                  }
              }
            },

            checkIsEditingDescription(){
              if(this.filterContext == "Tasks" || this.filterContext == "Review"){
                this.$emit("checkForUnsavedDescription", true);
              }
            },
            ...mapGetters("users",["getLoggedInUser","getLoggedInUserId","getLoggedInUserType", "getUsersBasicInfoFromStore"]),
            ...mapActions("users",["getUsersAutoComplitionFromServer","getAllUsersFromServer","getUserInfoFromServer","checkUserLoginStatus"]),
            ...mapActions("reviewDataTemp",["getReviewUsersWithAutocomplete"])
        },
        created(){
          if(!this.filterByUT){
            this.defaultUserTypes = ['SystemAdmin','SystemUser','Client']
          }else{
            this.defaultUserTypes = this.filterByUT;
          }
            if(Object.prototype.toString.call(this.selectedUserIdList) == '[object String]'){
              if(this.selectedUserIdList.length > 0){
                Object.assign(this.userIdList, [this.selectedUserIdList]);
              }else{
                Object.assign(this.userIdList, []);
              }
            }else{
              Object.assign(this.userIdList, this.selectedUserIdList);
            }
            this.fetchAndLoadUserNamesById();
            if(this.loggedInUserDataList != undefined && this.loggedInUserDataList.length){
                this.userTypes=this.loggedInUserDataList;
            }else if(this.selectedUserIdNameMap != undefined && this.selectedUserIdNameMap.length){
                this.userTypes=this.selectedUserIdNameMap;
            }
            if(this.enableAllOption != undefined && this.enableAllOption){
              this.userTypesOptions.unshift(this.allUsersData)
            }
        } ,
}
</script>


<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

.all-users-selection:hover{
  background: $bg-color-on-hover;
}

.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}
input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
    margin-inline-end: 5px;
}
::v-deep{
  .multiselect {
    width:100%;
    margin: 3px 0px;
    color:$text-color;
  }
  .multiselect__tags-wrap{
    display: block !important;
  }
  .multiselect__content-wrapper {
    display: none;
  }
  .multiselect__tag, .tags-style {
    background-color: $primary-background !important;
    border: $border-color;
    border-radius: 5px;
    margin-bottom:0px;
  }
  .multiselect__tags, .tags-style {
    background: $primary-background !important;
        border: $border-color !important;
  }

  .name-count-parent-wrap{
    background: transparent !important;
    border: none !important;
  }

  
  .multiselect__option--highlight {
    background: $bg-color-on-hover !important;
  }
  .multiselect__content {
    background: $secondary-background-color !important;
  }
  .multiselect__input,
  .multiselect__single {
    background: transparent !important;
    color: $text-color;
  }
  .multiselect__input:focus {
    outline: none;
    box-shadow: none;
  }
  .multiselect__tag-icon {
    color: $text-color !important;
  }
  .multiselect__tag-icon:focus,
  .multiselect__tag-icon:hover {
    background: $bg-color-on-hover !important;
    color: $text-color !important;
  }
  .multiselect__tag-icon:after {
    color: $secondary-text-color !important;
    font-size: 23px;
  }

  .multiselect__tag-icon {
    visibility: hidden;
  }

  .multiselect__tag:hover .multiselect__tag-icon {
    visibility: visible;
  }

  .multiselect * {
    font-size: $input-field-and-label-font-size !important;
    font-family: "Roboto", Arial, sans-serif !important;
  }
  .multiselect__placeholder {
    padding-top: 3px !important;
    margin-bottom:0px !important;
  }
  .multiselect {
    color: $text-color !important;
    font-size: $input-field-and-label-font-size !important;
    width: 40%;
    min-height: 38px;
  }
  .multiselect__single {
    padding-top: 3px;
  }
  .multiselect__option--selected {
    background: $bg-color-on-hover !important;
    color: $text-color;
  }
  .multiselect__content-wrapper {
    border: 1px solid $bg-color-on-hover !important;
    position: absolute;
    display: block;
    background: $text-color;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid $text-color;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 50;
    -webkit-overflow-scrolling: touch;
  }

  .multiselect__current,
  .multiselect__option {
    line-height: 12px !important;
  }

  .multiselect--above .multiselect__content-wrapper {
    background: $secondary-background-color !important;
  }
  .multiselect__tags {
    background: $primary-background !important;
    height: auto;
    padding: 8px 40px 8px 8px;
  }
}

.browse-icon{
    position: relative;
    inset-inline-start:8px;
    top: 3px;
}

.table td, .table th {
    border-top: none;
    padding:0px;
}

.display-as-tags{
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: start;
    float: inline-start;
}

.select-catalog-field{
    width: 101%;
    .value-style{
      width:100%;
    }
}

.user-name-or-image {
  height: 30px;
  width: 30px;
  border: $border-color;
  border-radius: 10px;
  text-align: center;
  line-height: 28px;
  text-transform: uppercase;
  margin-top: 3px;
  margin-inline-start: 5px;
}

.user-name-or-image-in-selected-option{
  border: 1px solid #3a3a3a;
  height: 27px;
  width: 27px;
  border-radius: 5px;
  text-align: center;
  line-height: 26px;
  text-transform: uppercase;
  margin-top: -1px;
  margin-inline-start: -1px;
  }

.tags-style{
    display: inline-flex;
    margin-inline-end: 5px;
    margin-bottom: 2px !important;
    height: 27px;
    margin-inline-start: 3px;
    float: inline-start;
  .user-name-display-as-tags{
      line-height: 27px;
      margin-inline-start: 6px;
  }
}

.name-count-parent-wrap{
    display: inline-flex;
    margin-inline-end: 5px;
    margin-bottom: -2px !important;
    height: 27px;
    margin-inline-start: 3px;
    div.customisez-label{
      padding-inline-end:5px;
      position: relative;
      top: 3px;
    }
   .name-count-wrap{
      display: inline-flex;
      position: relative;
      inset-inline-start:5px;
      .user-name-display-as-tags{
        line-height: 27px;
        margin-inline-start: 6px;
      }  
  }
}


.remove-tag{
  color:$dull-text-color;
  line-height: 25px;
}

.remove-tag:hover{
  color:$text-color;
}
.ellipsis-to-entry{
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 50px;
    inset-inline-start:2px;
}
</style>